// extracted by mini-css-extract-plugin
export default {"logo":"NBLogo_logo__anYFu"};